import { useContext } from 'react';
import { CompanyContext } from '../contexts/CompanyContext';

// ----------------------------------------------------------------------

const useCompany = () => useContext(CompanyContext);

export default useCompany;
